import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

/**
 * This guard is meant to be used for routes that should not be loadable
 * without authenticating with FloSports.  If they are not authenticated, then
 * it will redirect them to the login funnel where they will be redirected back
 * here once they authenticate.
 */
@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
protected authService: AuthService,
                protected router: Router,
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.authService.isLoggedIn()) {
            return true;
        }

        const nextUrl: string = document.location.href;
        this.router.navigate(['/login'], { queryParams: { next: nextUrl } });

        return false;
    }
}
